import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ShareEmailComponent } from '../share-email/share-email.component';
import * as docxPreview from 'docx-preview';
import * as XLSX from 'xlsx';
import { CommonService } from '../../service/common/common.service';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
@Component({
  selector: 'app-file-viewer',
  standalone: false,
  templateUrl: './file-viewer.component.html',
  styleUrl: './file-viewer.component.scss'
})
export class FileViewerComponent {
  @Input() url: any;
  @Input() files:any=[];
  @Input() file:any;
  @Input() fileSize: any;
 @Input() base64File: string | null = null;
@Input() fileUrl: string | null = null;
@Input() fileName: string = '';
  @Output() closeViewer = new EventEmitter<void>();
  zoomValue: number = 1.0;
  page: number = 1;
  totalPages: number = 1;
  rotationAngle: number = 0;
  searchTermInPdf: string = "";
  isFilePDFViewerChange: boolean = false;
  fileType: string;
  fileContent: string | ArrayBuffer;
  tableHtml: string | null = null;
  userDetails$ :Observable<any>;
  shareEmail: boolean;
  @Input() buttonConfig:any;
  @Output() sendEmailData: EventEmitter<any>=new EventEmitter<void>();
  @ViewChild(ShareEmailComponent) shareEmailComponent!: ShareEmailComponent;
  @ViewChild(PdfViewerComponent, { static: false }) private pdfViewer: PdfViewerComponent;
  currentUrl: string=window.location.href;
  sheetsData: any[]=[];
  isSuperuser: boolean=false;


  ngOnInit() {
    this.fileType = this.getFileType(this.fileName);
   setTimeout(() => {
    this.loadFileContent();
   }, 1000);
   this.userDetails$.subscribe(data => {
    this.isSuperuser=data?.is_superuser;
  });
  }

  constructor(private store: Store<any>,public messageService:MessageService){
    this.userDetails$ = this.store.pipe(select(state => state?.list?.data?.profile));
  }
   ngOnChanges(changes: SimpleChanges) {
    if (changes['base64File'] || changes['url'] || changes['files']) {
  this.fileType = this.getFileType(this.fileName);
this.loadFileContent();
    }
  }
  loadFileContent() {
    if (this.base64File) {
      this.fileType = this.getFileType(this.fileName);
      this.fileContent = this.base64File;
      if (this.isPDF()) {
        this.url = `data:application/pdf;base64,${this.base64File}`;
      } else if (this.isImage()) {
        this.fileContent = `data:image/${this.fileType};base64,${this.base64File}`;
      }
      else if (this.isText() || this.fileType === 'edi' || this.fileType === 'xml') {
        const byteCharacters = atob(this.base64File); // Decode base64
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const textDecoder = new TextDecoder('utf-8');
        this.fileContent = textDecoder.decode(byteArray);
          if (this.fileType === 'json') {
 try {
  const parsed = JSON.parse(this.fileContent);
  this.fileContent = JSON.stringify(parsed, null, 2);
} catch (e) {
  console.error('Invalid JSON', e);
}
  }
        else if(this.fileType!='xml'){
          this.fileContent=this.fileContent.replace(/\n/g, '<br>');
        }
      }
      else if(this.isExcelDocument()){
   let blob = this.base64ToBlob(
  this.base64File,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
);

const reader = new FileReader();

reader.onload = (e: any) => {
  try {
    const arrayBuffer = e.target.result;

    const workbook = XLSX.read(new Uint8Array(arrayBuffer), {
      type: 'array',
      cellDates: true
    });

 const sheetsData = workbook.SheetNames.map(sheetName => {
  const worksheet = workbook.Sheets[sheetName];

  const sheetArray: any[][] = XLSX.utils.sheet_to_json(worksheet, {
    header: 1,
    raw: false,
    dateNF: 'yyyy-mm-dd hh:mm:ss'
  });

  return {
    name: sheetName,
    headers: sheetArray?.[0] || [],
    rows: sheetArray?.slice(1) || [],
    totalRows: Math.max((sheetArray?.length || 1) - 1, 0)
  };
});

this.sheetsData = sheetsData;
  } catch (error) {
    console.error('Error processing the Excel file:', error);
  }
};

reader.readAsArrayBuffer(blob);
      }
      else if(this.isDocxDocument()){
      this.loadDocxPreviewFromBase64(this.base64File);
    }
    } else{
    const fileReader = new FileReader();
    let file=this.files?.[0];
    if (this.isText()) {
      fileReader.readAsText(file);
      fileReader.onload = () => {
        this.fileContent = fileReader.result;
        if(this.fileType?.includes('json')){
          let fileContent=this.fileContent?.toString();
          try {
            const preprocessedString = fileContent
              .replace(/None/g, 'null')
              .replace(/False/g, 'false')
              .replace(/True/g, 'true');
            this.fileContent = JSON.parse(preprocessedString);
          } catch (error) {
            this.fileContent = this.fileContent;
          }
        }
      };
    } else if (this.isImage()) {
      this.fileContent = this.url;
    } else if (this.isPDF()) {
      this.url = this.url;
    }
    else if(this.isDocxDocument()){
      this.loadDocxPreview(file);
    }
    else if (this.isExcelDocument()) {
    const reader = new FileReader();
reader.onload = (e: any) => {
  try {
    const arrayBuffer = e.target.result;
    const data = new Uint8Array(arrayBuffer);
    const workbook = XLSX.read(data, {
      type: 'array',
      cellDates: true
    });
const sheetsData = workbook.SheetNames.map(sheetName => {
  const worksheet = workbook.Sheets[sheetName];

  const sheetArray: any[][] = XLSX.utils.sheet_to_json(worksheet, {
    header: 1,
    raw: false,
    dateNF: 'yyyy-mm-dd hh:mm:ss'
  });

  return {
    name: sheetName,
    headers: sheetArray?.[0] || [],
    rows: sheetArray?.slice(1) || [],
    totalRows: Math.max((sheetArray?.length || 1) - 1, 0)
  };
});

this.sheetsData = sheetsData;
  } catch (error) {
    console.error('Error processing the Excel file:', error);
  }
};
reader.readAsArrayBuffer(file);
    }
    else if (this.isPPTFile()) {
      this.loadOfficeDocument(file);
    }
     else {
      console.warn('Unsupported file type');
    }
  }
  }
  
  base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: type });
  }

  trackByIndex(index: number): number {
  return index;
}

  getFileType(fileName: string): string {
    const extension = fileName?.split('.').pop()?.toLowerCase();
    return extension ? extension : '';
  }

  isPDF() {
    return this.fileType === 'pdf';
  }

  isImage() {
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(this.fileType);
  }

  isText() {
    return ['txt', 'json', 'xml', 'edi'].includes(this.fileType);
  }

  loadOfficeDocument(file: any) {
    this.url = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        URL.createObjectURL(file)
      )}`
  }
 
loadDocxPreview(file: File) {
  const fileReader = new FileReader();

  fileReader.onload = (event) => {
    const arrayBuffer = event.target?.result as ArrayBuffer;
    const container = document.getElementById('docx-preview-container');
    if (container) {
      container.innerHTML = ''; 
      if (container) {
        docxPreview.renderAsync(arrayBuffer, container, null, {
          className: 'docx-preview',
          inWrapper: true,
          ignoreWidth: true,
          ignoreHeight: true,
          ignoreFonts: false,
          breakPages: true,
          ignoreLastRenderedPageBreak: false,
          experimental: false,
          trimXmlDeclaration: true,
          useBase64URL: false,
          renderChanges: false,
          renderHeaders: true,
          renderFooters: true,
          renderFootnotes: true,
          renderEndnotes: true,
          renderComments: false,
          debug: false,
        }).catch(error => {
          console.error('Error rendering DOCX file:', error);
        });
      } else {
        console.error('Container element not found.');
      }
    }
  };

  fileReader.onerror = (error) => {
    console.error('Error reading file:', error);
  };

  fileReader.readAsArrayBuffer(file); // Read file as ArrayBuffer
}
loadDocxPreviewFromBase64(base64String: string) {
  const byteCharacters = atob(base64String); // Decode base64 to binary string
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const arrayBuffer = byteArray.buffer;
  const container = document.getElementById('docx-preview-container');
  
  if (container) {
    container.innerHTML = ''; 
    docxPreview.renderAsync(arrayBuffer, container, null, {
      className: 'docx-preview',
      inWrapper: true,
      ignoreWidth: true,
      ignoreHeight: true,
      ignoreFonts: false,
      breakPages: true,
      ignoreLastRenderedPageBreak: false,
      experimental: false,
      trimXmlDeclaration: true,
      useBase64URL: false,
      renderChanges: false,
      renderHeaders: true,
      renderFooters: true,
      renderFootnotes: true,
      renderEndnotes: true,
      renderComments: false,
      debug: false,
    }).catch(error => {
      console.error('Error rendering DOCX file:', error);
    });
  } else {
    console.error('Container element not found.');
  }
}

  isPPTFile() {
    return ['ppt', 'pptx'].includes(this.fileType);
  }

  isExcelDocument(){
    return ['xls', 'xlsx','csv'].includes(this.fileType);
  }
  isDocxDocument(){
    return 'docx'==this.fileType;
  }
  zoomOut() {
    this.zoomValue -= 0.1;
  }
  zoomIn() {
    this.zoomValue += 0.1;
  }
  prevPage() {
    this.page--;
  }
  nextPage() {
    this.page++;
  }
  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData?._pdfInfo?.numPages;
  }
  pagechanging(event) {
    this.page = event?.pageNumber;
  }
  rotatePdf() {
    this.rotationAngle += 90;
  }

  printPdf(): void {
    if (this.isDocxDocument() || this.isExcelDocument()) {
      let containerId=''
      if(this.isDocxDocument()){
      containerId = 'docx-preview-container';
      }
      if(this.isExcelDocument()){
      containerId = 'excel-sheet';
      } 
      setTimeout(() => {
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';  
        iframe.style.width = '1px'; 
        iframe.style.height = '1px'; 
        iframe.style.opacity = '0';  
        document.body.appendChild(iframe);
        const container = document.getElementById(containerId);
        if (container && iframe.contentWindow) {
          const htmlContent = `
          <html>
            <head>
              <style>
                table {
                  width: 100%;
                  border-collapse: collapse;
                }
                table, th, td {
                  border: 1px solid black;
                }
                th, td {
                  padding: 5px;
                  text-align: left;
                }
                .sheet-title {
                  font-size: 16px;
                  font-weight: bold;
                }
              </style>
            </head>
            <body>
              ${container.innerHTML}  <!-- Excel data as table -->
            </body>
          </html>
        `;
          iframe.contentWindow.document.open();
          iframe.contentWindow.document.write(htmlContent); 
          iframe.contentWindow.document.close();
          iframe.onload = () => {
            try {
              iframe.contentWindow?.focus();
              iframe.contentWindow?.print();
            } catch (error) {
              console.error('Error triggering print:', error);
            } finally {
              document.body.removeChild(iframe);
            }
          };
        } else {
          console.error('Iframe contentWindow not found.');
        }
      }, 1000);
    } else {
      // Handle other file types (like PDFs)
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none'; // Hide the iframe
      iframe.src = CommonService.generateFileUrl(this.base64File, this.fileName)?.toString();
      document.body.appendChild(iframe);
      
      iframe.onload = () => {
        try {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
        } catch (error) {
          console.error('Error triggering print:', error);
        }
      };
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key?.toLowerCase() === 'p') {
      event.preventDefault(); 
      this.printPdf(); 
    }
  }
  searchPdf(pdfViewer) {
    this.pdfViewer.eventBus.dispatch('find', {
      query: this.searchTermInPdf, type: 'again', caseSensitive: false, findPrevious: undefined, highlightAll: true, phraseSearch: true
    });
  }
  searchText(jsonViewElementRef){
    const jsonViewElement = jsonViewElementRef?.nativeElement;
    const markElement = jsonViewElement?.querySelector('mark');
    if (markElement) {
      markElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  encodeXml(xml: string): string {
    return xml.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  onChangeFileView() {
    this.isFilePDFViewerChange = !this.isFilePDFViewerChange;
  }
  onClickCopyUrl(){
   const currentUrl= window.location.href; 
  if (navigator.clipboard) {
    navigator.clipboard.writeText(currentUrl).then(() => {
    }).catch(err => {
      console.error('Failed to copy URL: ', err);
    });
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'URL copied to clipboard!' });
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = currentUrl;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
  }
  onClickShareDocument(){
    this.shareEmail=true;
  }

  onClickShare(event){
   this.sendEmailData.emit(event);
   setTimeout(() => {
    this.shareEmail=false;
   }, 1000);
  }
  onClickReset(){
    this.shareEmail=false;
  }
  onHideModal(){
    if (this.shareEmailComponent) {
      this.shareEmailComponent.resetReplyForm();  // Reset the form when the modal is hidden
    }
  }

  onClickDownloadDocument(){
  let url=CommonService.generateFileUrl(this.base64File,this.fileName);
  const link = document.createElement('a');
  link.href = url;
  link.target='_blank'
  link.download = this.fileName??'Astro_Document'; 
  link.click();
  window.URL.revokeObjectURL(url);
  }

  formatFileSize(bytes: number): string {
    if (bytes == null || bytes === undefined) {
      return '';  // Handle null or undefined values
    }
    const kb = bytes / 1024;
    const mb = kb / 1024;
    if (mb >= 1) {
      return `(${mb?.toFixed(2)} MB)`;  // If file size is 1 MB or more, display in MB
    } else {
      return `(${kb?.toFixed(2)} KB)`;  // Otherwise, display in KB
    }
  }

  onClose() {
    this.closeViewer.emit();
  }

}
